(() => {
  const cleanups = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('.joel-featured').forEach(section => {
      const track = section.querySelector('[data-product-track]');
      if (!track || track.dataset.ready) return;
      track.dataset.ready = 'true';
      const cards = [...track.children];
      const previous = section.querySelector('[data-track-prev]');
      const next = section.querySelector('[data-track-next]');
      const position = section.querySelector('[data-track-position]');
      const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const update = () => {
        const index = Math.min(cards.length, Math.round(track.scrollLeft / Math.max(1, step())) + 1);
        position.textContent = `${index} of ${cards.length}`;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      const back = () => move(-1);
      const forward = () => move(1);
      previous.addEventListener('click', back);
      next.addEventListener('click', forward);
      const keydown = event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      };
      track.addEventListener('keydown', keydown);
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      cleanups.set(section, () => {
        window.removeEventListener('resize', update);
        track.removeEventListener('scroll', update);
        track.removeEventListener('keydown', keydown);
        previous.removeEventListener('click', back);
        next.removeEventListener('click', forward);
        delete track.dataset.ready;
        cleanups.delete(section);
      });
      update();
    });
  }
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.joel-featured').forEach(section => cleanups.get(section)?.());
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
